import { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { DropDown, TextBox } from '../../shared/controls/form';

const validationSchema = Yup.object().shape({
  accountName: Yup.string().required('Account Name is required'),
  parentAccount: Yup.string().required('Parent Account is required'),
  phone: Yup.string()
    .required('Phone is required')
    .matches(/^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/, 'Phone number is not valid'),
  website: Yup.string()
    .required('Website is required')
    .matches(
      /^((https?:\/\/)?([a-zA-Z0-9-]+\.)+(@|com|net|org|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)\b)((\/[a-zA-Z0-9-._~:\/?#\[\]@!$&'()*+,;=]*)?)$/,
      'Invalid website URL'
    ),
  annualRevenue: Yup.string().required('Annual Revenue is required'),
  billingCountry: Yup.string().required('Billing Country is required'),
});

const AddCallsNowForm = ({ handleCloseLogForm, handleFormSubmit, callData, openNow, callList }) => {
  const [formData, setFormData] = useState(callData);
  const [errormsg, setErrorMsg] = useState({});

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
  };

  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleDropdownChange = (selectedId, e, name, displayName, flag) => {
    const selectedValue = e.currentTarget.textContent;

    // Update formData with the selected value for the dropdown
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
      [displayName]: undefined,
    }));
    setFormData({
      ...formData,
      [name]: selectedId,
      [displayName]: selectedValue,
    });
  };

  return (
    <div className="modal-form">
      <div
        className={`modal fade ${openNow ? 'show' : ''}`}
        id="callModal"
        tabIndex="-1"
        aria-labelledby="callModalLabel"
        aria-hidden="true"
        style={{
          display: openNow ? 'flex' : 'none',
          justifyContent: 'centr',
        }}
      >
        <div className="modal-dialog" style={{ width: '1080px' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fs-5" id="accountModalLabel">
                Call Now
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseLogForm}
              ></button>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={formData}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div className="form">
                    <div className="subHeading">Call Information</div>
                    <div className="two-inputs2">
                      <div className="input-container">
                        <DropDown
                          label={'Select From'}
                          name={'selectFromId'}
                          displayName={'selectFrom'}
                          // isRequired={true}
                          placeholder={'Select From'}
                          // value={formData.selectFrom}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.selectFromId}
                        />
                      </div>
                      <div className="input-container">
                        <DropDown
                          label={'Call To'}
                          name={'callToId'}
                          displayName={'callTo'}
                          // isRequired={true}
                          placeholder={'Select Call To'}
                          // value={formData.callTo}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.callToId}
                        />
                      </div>
                    </div>

                    <div className="two-inputs2">
                      <div className="input-container">
                        <DropDown
                          label={'Select From'}
                          name={'selectFromId'}
                          displayName={'selectFrom'}
                          placeholder={'Select From'}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.selectFromId}
                        />
                      </div>
                      <div className="input-container">
                        <DropDown
                          label={'Related To'}
                          name={'relatedToId'}
                          displayName={'relatedTo'}
                          placeholder={'Select Related To'}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.relatedToId}
                        />
                      </div>
                    </div>
                    <div className="subHeading">Purpose of Outgoing Call</div>
                    <div className="input-container">
                      <DropDown
                        label={'Call Purpose'}
                        name={'callPurposeId'}
                        displayName={'callPurpose'}
                        placeholder={'Select Call Purpose'}
                        handleSelect={handleDropdownChange}
                        options={callList}
                        optionKeys={['id', 'name']}
                        errormsg={errormsg.callPurposeId}
                      />
                    </div>
                    <div className="input-container">
                      <TextBox
                        label={'Call Agenda'}
                        name={'callAgenda'}
                        placeholder={'Call Agenda'}
                        handleSelect={handleChangeForm}
                        errormsg={errormsg.callPurpose}
                      />
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                onClick={handleCloseLogForm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleSubmit(formData);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCallsNowForm;
